module.exports = __webpack_public_path__ + "c45cb017530ab9fc535089002bf3dad3.ttf";